<template>
  <div class="tabs">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(tab, index) in tabs"
        :key="index"
        :label="tab"
        :name="index"
      >
        {{ tab }}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.tabs {
  .el-tabs__item {
    font-size: 1.2rem;
    text-transform: uppercase;
    color: $light_gray;
    height: 2rem;
    line-height: 2rem;
    &.is-active {
      color: $text;
      font-weight: 700;
    }
  }

  .el-tabs__active-bar {
    background-color: $text;
    &:after {
      content: "";
      position: absolute;
      left: calc(50% - 0.6rem);
      bottom: -1.2rem;
      border: 0.6rem solid transparent;
      border-top: 0.6rem solid $text;
    }
  }
  .el-tabs__nav-scroll {
    padding-bottom: 1rem;
  }
  .el-tabs__nav-wrap::after {
    bottom: 1rem;
    height: 1px;
    background-color: $border;
  }
}
</style>
